var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89583 0C7.28917 0 9.22917 1.94 9.22917 4.33333C9.22917 5.40667 8.83583 6.39333 8.18916 7.15333L8.36916 7.33333H8.89583L12.2292 10.6667L11.2292 11.6667L7.89583 8.33333V7.80667L7.71583 7.62667C6.95583 8.27333 5.96917 8.66667 4.89583 8.66667C2.5025 8.66667 0.5625 6.72667 0.5625 4.33333C0.5625 1.94 2.5025 0 4.89583 0ZM4.89613 1.33301C3.22947 1.33301 1.89613 2.66634 1.89613 4.33301C1.89613 5.99967 3.22947 7.33301 4.89613 7.33301C6.5628 7.33301 7.89613 5.99967 7.89613 4.33301C7.89613 2.66634 6.5628 1.33301 4.89613 1.33301Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.240628e42e7d981d70bab781947d2ce9.svg";
export { ForwardRef as ReactComponent };